import React from "react";
import { Text, i18n, tokens, Button, Theme } from "@simplybenefits/sb-ui-library";
import Grid from "@mui/material/Grid";
import { Launch } from "@mui/icons-material";

/**
 * 
 * @param {*} title
 * @param {*} isIncludedInPlan
 * @param {*} icon
 * @param {*} description
 * @param {*} navigation
 * @param {*} whitelabel
 * @param {*} customIconStyle
 * @returns {React.element}
 */
const Tile = ({ 
    title, 
    isIncludedInPlan = false, 
    icon, 
    description, 
    navigation, 
    whitelabel = {},
    customIconStyle = {}
}) => {
    const styles = {
        container: {
            display: "flex", 
            flexDirection: "column",
            height: "100%",
            backgroundColor: Theme.colors.surface,
            border: `1px solid ${ Theme.colors.lightGrey }`,
            borderRadius: 6
        },
        descriptionContainer: {
            paddingRight: 27,
            paddingLeft: 40,
            paddingTop: 19,
            marginBottom: 24,
            flexGrow: 1
        },
        titleContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 14
        },
        icon: { 
            width: 50,
            height: 50,
            marginRight: 20,
            ...customIconStyle
        },
        subTitle: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue,
            borderRadius: 20,
            backgroundColor: whitelabel.lightColor || Theme.colors.lightBlue,
            paddingRight: 7,
            paddingLeft: 7,
            display: "inline-block"
        },
        divider: {
            borderBottom: `1px solid ${ Theme.colors.lightGrey }`
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            height: 50,
            marginRight: 13
        },
        buttonIcon: {
            width: 15,
            height: 15,
            marginRight: 5,
            color: whitelabel.primaryColor || Theme.colors.skyBlue 
        }
    };

    /**
     * @param {*} destination
     */
    const _handleNavigation = (destination) => {
        if (typeof destination === "function") {
            destination();
        } else {
            window.open(destination, "_blank");
        }
    };

    return (
        <Grid item xs={12} md={6} lg={4} xl={4}>
            <div style={ styles.container }>
                <div style={ styles.descriptionContainer }>
                    <div style={ styles.titleContainer }>
                        <img src={ icon } style={ styles.icon }/>
                        <div>
                            <Text medium bold>{ title }</Text>
                            {
                                isIncludedInPlan ?
                                    <Text
                                        superTiny
                                        bold 
                                        customStyle={ styles.subTitle }
                                    >
                                        { i18n.t(tokens.labels.perks.includedInYourPlan) }
                                    </Text>
                                    : null
                            }
                        </div>
                    </div>
                    <Text>{ description }</Text>
                </div>
                <div style={ styles.divider }/>
                <div style={ styles.buttonContainer }>
                    <Button 
                        transparent
                        noHover
                        onClick={() => _handleNavigation(navigation)}
                    >
                        <Launch style={ styles.buttonIcon }/>
                        <Text
                            small
                            bold
                            color={ whitelabel.primaryColor || Theme.colors.skyBlue}
                        >
                            { i18n.t(tokens.labels.perks.viewProduct) }
                        </Text>
                    </Button>
                </div>
            </div>
        </Grid>
    );
};

export default Tile;